import React from 'react';
import styled from 'styled-components';

const ModernCard = ({ 
  title, 
  value, 
  icon, 
  percentage, 
  fillPercentage = 76,
  iconColor = "#10B981",
  fillColor = "#10B981",
  onClick,
  isSelected = false
}) => {
  return (
    <StyledWrapper>
      <div 
        className={`card ${onClick ? 'clickable' : ''} ${isSelected ? 'selected' : ''}`}
        onClick={onClick}
      >
        <div className="title">
          <span style={{ backgroundColor: iconColor }}>
            {icon}
          </span>
          <p className="title-text">
            {title}
          </p>
          {percentage && (
            <p className="percent">
              <svg width={20} height={20} fill="currentColor" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                <path d="M1408 1216q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z">
                </path>
              </svg> {percentage}%
            </p>
          )}
        </div>
        <div className="data">
          <p>
            {value}
          </p>
          <div className="range">
            <div 
              className="fill" 
              style={{ 
                backgroundColor: fillColor, 
                width: `${fillPercentage}%` 
              }}
            >
            </div>
          </div>
        </div>
      </div>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  .card {
  padding: 0.5rem;

  background-color: #F4F7FB;
  max-width: 240px;
  min-width: 200px;
  border-radius: 14px;
  /* correct border */
  border: 1px solid #6415e4ff;

  /* subtle depth */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);

  transition: transform 0.2s ease,
              box-shadow 0.2s ease,
              border-color 0.2s ease;
              height: auto;        /* 🔥 remove fixed height */
  min-height: 40px;    /* keeps visual consistency */



   border: 1px solid #E2E8F0;
   box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
}


  .card.clickable {
    cursor: pointer;
  }

  .card.clickable:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  }

  .card.selected {
    border-color: #3B82F6; /* professional blue */
    box-shadow: 0 8px 24px rgba(59, 130, 246, 0.18);
    background: linear-gradient(135deg, #EFF6FF 0%, #ffffff 100%);
  }

  .title {
    display: flex;
    align-items: center;
  }

  .title span {
    position: relative;
    padding: 0.25rem;
    background-color: #10B981;
    width: 0.95rem;
    height: 0.95rem;
    border-radius: 9999px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title span svg {
    color: #ffffff;
    height: 0.6rem;
    width: 0.65rem;
  }

  .title-text {
    margin-left: 0.3rem;
    color: #374151;
    font-size: 12px;
    font-weight: 600;
    flex: 1;
  }

  .percent {
    margin-left: 0.3rem;
    color: #02972f;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 2px;
    font-size: 8px;
  }

  .data {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .data p {
    margin-top: 0.2rem;
    margin-bottom: 0.15rem;
    color: #1F2937;
    text-align: left;
    font-size: 1.1rem;     /* 👈 reduce */
  line-height: 1.1rem;
  font-weight: 700;
  }

  .data .range {
    position: relative;
    background-color: #E5E7EB;
    width: 100%;
    height: 0.3rem;
    border-radius: 0.15rem;
    margin-top: 0.3rem;
  }

  .data .range .fill {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #10B981;
    height: 100%;
    border-radius: 0.15rem;
    transition: width 0.3s ease;
  }
`;

export default ModernCard;